import { useNavigate, useRouterState } from "@tanstack/react-router";
export function useViewSearch<T extends string>(key:string,allowed:readonly T[],fallback:T):[T,(value:T)=>void] {
  const search=useRouterState({select:s=>s.location.search}); const navigate=useNavigate();
  const raw=(search as Record<string, unknown>)[key]; const value=typeof raw==='string'&&allowed.includes(raw as T)?raw as T:fallback;
  return [value,next=>{void navigate({to:'.',search:previous=>{const search={...previous} as Record<string,unknown>; if(next==='') delete search[key]; else search[key]=next; return search;}});}];
}
